import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_DOMAIN } from "config";
import useDisplayMode from "useDisplayMode";
import CarsTable    from "components/CarsTable";
import OffersTable  from "components/OffersTable";
import SendNewOfferPopup from "components/SendNewOfferPopup";
import { Heading, Img, Button, Text } from "../../components";

/* מונים ריקים */
const EMPTY_COUNTERS = {
  ads_all: 0, ads_new: 0, ads_archive: 0, ads_pending: 0,
  offers_new: 0, offers_approved: 0,
  cars_auction: 0, bundles_auction: 0,
};

export default function DashboredDealer({
  currentUser,
  /* מונים של הלוח הקטן בצד שמאל */
  setDealerCounters: pushToAppCounters,
}) {
  /* —————————————————— state —————————————————— */
const [localCounters, setLocalCounters] = useState(EMPTY_COUNTERS);
  const [cars,   setCars]   = useState([]);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [displayMode, setDisplayMode] = useDisplayMode();
  const [reload, setReload] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [showOfferPopup, setShowOfferPopup] = useState(false);
  const location = useLocation();
  const navigate  = useNavigate();
const [allCars, setAllCars] = useState([]);

const pushCounters = (patch) => {
  setLocalCounters(prev => ({ ...prev, ...patch }));      // ← רק לוקאלית לדשבורד
  pushToAppCounters(prev => ({ ...prev, ...patch }));     // ← שולחת לאפליקציה
};

  /* ——————————————————   Cars   —————————————————— */
const fetchCars = useCallback(async () => {
  if (!currentUser?.id) return;
 const { data } = await axios.get(`${API_DOMAIN}/car/filterCars`, {
   params: { userId: currentUser.id, pageSize: 1000000 }   // ⬅️ מושך הכול
 });
  setAllCars(data); // שומר את כל הרכבים המלאים

  // מציגים רק רכבים חדשים
const newCars = data.filter(
  (c) => c.offer_status === 0 || c.offer_status === null
);
  setCars(newCars);

  // מחשבים מונים מהכל
  // חישוב מונים רגילים
  const adsAll = data.length;
  const adsNew = data.filter(c => c.offer_status === 0 || c.offer_status === null).length;
  const adsArchive = data.filter(c => [4, 5].includes(c.offer_status)).length;
  const adsPending = data.filter(c => c.offer_status === 1).length;

  // חישוב מונים למכרזים (גמיש — תומך בשמות שדות שונים מהשרת)
  let carsAuction = 0;
  let carsAuctionFuture = 0;
  let bundlesAuction = 0;
  const now = Date.now();

  data.forEach((c) => {
    // detect if car is currently in auction
    const inAuction = !!(
      c.in_auction ||
      c.auction === 1 ||
      c.is_in_auction ||
      c.auction_active === 1 ||
      c.auction_status === "active" ||
      c.auction_status === 2
    );

    // detect auction start date (various possible field names)
    const startRaw = c.auction_start || c.auction_start_date || c.auction_from || c.auctionFrom || c.start_date || c.auctionDate;
    let startTs = null;
    if (startRaw) {
      const parsed = Date.parse(startRaw);
      if (!Number.isNaN(parsed)) startTs = parsed;
    }

    if (inAuction) carsAuction += 1;
    else if (startTs && startTs > now) carsAuctionFuture += 1;

    // detect bundle/package auctions
    if (c.is_bundle || c.is_package || c.package_id || c.bundle_id) bundlesAuction += 1;
  });

  pushCounters({
    ads_all: adsAll,
    ads_new: adsNew,
    ads_archive: adsArchive,
    ads_pending: adsPending,
    cars_auction: carsAuction,
    cars_auction_future: carsAuctionFuture,
    bundles_auction: bundlesAuction,
  });
}, [currentUser?.id]);


  /* ——————————————————  Offers  —————————————————— */
  const fetchOffers = useCallback(async () => {
    if (!currentUser?.id) return;
    const { data } = await axios.get(
      `${API_DOMAIN}/offer/filterOffers`,
      { params: { userId: currentUser.id } }
    );
    setOffers(data);
pushCounters({
  offers_new:      data.filter(o => o.offer_status === 1).length,
  offers_approved: data.filter(o => o.offer_status === 2).length,
});


  }, [currentUser?.id]);

  /* —————————————————— Polling + רענון —————————————————— */
  useEffect(() => { fetchCars();   const id=setInterval(fetchCars,   120_000); return () => clearInterval(id); }, [fetchCars]);
  useEffect(() => { fetchOffers(); const id=setInterval(fetchOffers, 120_000); return () => clearInterval(id); }, [fetchOffers]);
  useEffect(()  => { fetchCars(); fetchOffers(); }, [reload]);


  return (
    <>
      <div className="dashboard-dealer-section flex bg-blue_gray-50 p-8 sm:p-4" style={{ paddingTop: '1rem' }}>
        <div className="hide-mobile w-[100%] items-start gap-4 md:flex-col" style={{gap: '2%'}}>
        <div className=" flex relative flex-1 flex-col gap-8 self-center rounded-[24px]  p-1 md:self-stretch sm:p-4">
          <header className="flex flex-col items-start gap-3">

              <div style={{background: 'white', padding: '1rem', borderRadius:'10px'}} className="flex items-center justify-between gap-5 self-stretch border-b border-solid border-gray-200 md:flex-col">
                <div className="flex w-[6%] justify-center gap-3.5 md:w-full">
 
          
                </div>
{/*hhh*/}
                
                <div className="flex gap-3"> <div
                style={{background:'white'}}
             className="absolute left-[20px] h-8 w-[18%] bg-[rgb(239,240,241)] 
                        flex items-center justify-center 
                        rounded-br-[10px] "
           > 
                                    {/*<div className="flex w-full justify-center gap-1">
                                      <Heading size="headinglg" as="h2" className="text-[12px] font-bold !text-gray-900_04">
                                        <span className="text-gray-900_04">&nbsp;</span>
                                        <span className="font-heebo font-medium text-gray-600">מודעות רכבים</span>
                                      </Heading>
                                      <Img src="images/img_signal_red_a700_03_16x16.svg" alt="Signal" className="h-[16px]" />
                                    </div>
                                    <div className="flex w-full items-center justify-center">
                                      <Heading size="textxs" as="h3" className="!font-heebo text-[12px] font-medium !text-gray-600">
                                       סוחר
                                      </Heading>
                                      <Img src="images/img_vector_deep_orange_500.svg" alt="Image" className="h-[16px]" />
                                    </div>*/}
                  </div>
                  <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
                     דשבורד
                  </Heading>
                  <Img src="/images/dashboard.svg" alt="Car" className="h-[25px] " />
                </div>
              </div>
            </header>
            <div className="flex flex-col gap-6">

 <div style={{width: '9%'}} className="ml-4 w-[9%] absolute top-5 left-0 h-8  flex items-center justify-center gap-4 rounded-br-[10px] md:px-5">
                <div className="flex w-full justify-center gap-1">
                  <Heading size="headinglg" as="h2" className="text-[12px] font-bold !text-gray-900_04">
                    <span className="text-gray-900_04">&nbsp;</span>
                    <span className="font-heebo font-medium text-gray-600">דשבורד</span>
                  </Heading>
                  <Img src="images/img_signal_red_a700_03_16x16.svg" alt="Signal" className="h-[16px]" />
                </div>
                <div className="flex w-full items-center justify-center">
                  <Heading size="textxs" as="h3" className="!font-heebo text-[12px] font-medium !text-gray-600">
                    סוחר
                  </Heading>
                  <Img src="images/img_vector_deep_orange_500.svg" alt="Image" className="h-[16px]" />
                </div>
              </div>


       <div>
      <div style={{background: 'white', padding: '1rem', borderRadius:'10px 10px 0 0'}} className="flex items-center justify-between gap-5 self-stretch border-b border-solid border-gray-200 md:flex-col">
              <div className="flex items-center gap-[18px]">   
 
          
                </div>
            <div 
            onClick={() => navigate("/dealer-cars")}
            className="flex items-center justify-center gap-[18px] cursor-pointer">
             <Img src="/images/black-arrow.svg" alt="כל ההצעות" className="h-[10px]" />
              <Heading
                size="h4_assistant_16px_b"
                as="h6"
                className="text-[16px] font-semibold  lg:text-[13px]"
                                style={{color: 'black'}}

              >
                כל הרכבים
              </Heading>
            </div>
                
                <div className="flex gap-3 ml-auto">   
                
                  <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
                     מודעות רכבים
                  </Heading>
                  <Img src="images/img_car_red_a700_03_1.svg" alt="Car" className="mt-1 h-[30px] " />
                </div>

                
              </div>
  <div className="scrol-wrapper2 flex flex-col " style={{backgroundColor:'white', borderRadius: '0 0 10px 10px', padding: '1rem'}}>
                  { 
                    <CarsTable cars={cars}
                    currentUser={currentUser} 
                    onUpdate={() => setReload(v => !v)} 
                   />}
      </div>       
</div>





        <div>
      <div style={{background: 'white', padding: '1rem', borderRadius:'10px 10px 0 0'}} className="flex items-center justify-between gap-5 self-stretch border-b border-solid border-gray-200 md:flex-col">
                <div className="flex justify-center gap-3.5 md:w-full">
 
          
                </div>

       <div 
  onClick={() => navigate("/my-offers")}
  className="flex items-center gap-[18px] cursor-pointer mr-auto "
>
  <Img src="/images/black-arrow.svg" alt="כל ההצעות" className="h-[10px]" />
  <Heading
    size="h4_assistant_16px_b"
    as="h6"
    className="text-[16px] font-semibold  lg:text-[13px]"
                    style={{color: 'black'}}

  >
    כל ההצעות
  </Heading>
</div>

                <div className="flex gap-3">
                
                  <Heading size="heading9xl" as="h4" className="!font-heebo text-[25px] font-bold lg:text-[21px]">
                     הצעות מחיר 
                  </Heading>
                  <Img src="/images/img_user_red_a700_03_1.svg" alt="Car" className="mt-1 h-[25px] " />
                </div>
              </div>
  <div className="scrol-wrapper2 flex flex-col " style={{backgroundColor:'white', borderRadius: '0 0 10px 10px', padding: '1rem'}}>
                           { 
           <OffersTable
  cars={offers}
  currentUser={currentUser}
  onUpdate={() => setReload(v => !v)}
  /* 👇 החדש: */
  onOfferClick={(offer) => {
    setSelectedOffer(offer);
    setShowOfferPopup(true);
  }}
/>

                   }     
      </div>       
</div>


            </div>

{showOfferPopup && selectedOffer && (
  <SendNewOfferPopup          /* או ApproveOfferByProviderPopup אם זה הצד של ספק */
    car={selectedOffer}       // כל פרטי הרכב
    offer={selectedOffer}     // ופרטי ההצעה
    currentUser={currentUser}
    onUpdateOffer={(upd) =>
      setOffers(prev =>
        prev.map(o => (o?.offer_id === upd?.offer_id ? { ...o, ...upd } : o))
      )}
    onClose={() => setShowOfferPopup(false)}
  />
)}

            
          </div>
          
        </div>

        
      </div>
      
    </>
  );
}
